module.exports = __webpack_public_path__ + "img/home_lottery_type3.c241449b.png";